import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastyModule } from '@haithamsboui/ng-toasty';
import { LoginRoutingModule } from './login-routing.module';
import { AlertModule } from '../../shared/components/alert/alert.module';

@NgModule({
  declarations: [LoginComponent],
  imports: [
    CommonModule,
    SharedModule,

    ToastyModule,
    FormsModule,
    ReactiveFormsModule,
    LoginRoutingModule,
    AlertModule,
  ],
})
export class LoginModule {}
